export interface Candidate {
  id: number;
  chrom: string;
  sample_sequence_run: {
    id: number;
    batch_label: string;
    barcode: string;
    sample: {
      kit_barcode: string;
    };
    test_types: string[];
    limitations: string[];
  };
  gene_ratio?: string;
  sample_ratio?: string;
  sample_ratio_links?: Record<string, string>;
  pca_plot?: string;
  raw_pca_plot?: string;
  start: number;
  end: number;
  region_name: string;
  inserted_seq?: string;
  cnv_class: string;
  insertion_assembly_link?: string;
  insertion_model_features?: {
    insertion_desc: string;
  };
  median_ratio?: number;
  copy_number: number;
  size: number;
  splitread_count: number;
  lumpy_su?: number;
  lumpy_pe?: number;
  lumpy_qual?: number;
  range_igv_link: string;
  usd_confidence?: string;
  usd_allele_fraction?: number;
  usd_total_unique_reads?: number;
  filtered_nomenclatures: string;
  similar_call_counts: [string, number][];
  tags: string[];
  review_decision: string;
  review_note: string;
  algorithm: string;
  clean_start_label: string;
  clean_end_label: string;
  nearby_long_indels: [string, string][];
  control_igv_links: [string, string, number][];
  breakpoint_igv_links: [string, string][];
  igv_link: string;
  why_cant_reset_review_decision?: string;
  review_on_hold?: boolean;
  does_overlap_pms2_12_15: boolean;
}

export interface CNVReviewData {
  id: number;
  review_decision: string;
  review_note: string;
}

export interface ReviewOnHoldData {
  cnv_candidate_ids: number[];
  hold: boolean;
}

export enum ReviewDecision {
  UNKNOWN = 'unknown',
  PRESENT = 'present',
  ABSENT = 'absent',
  MAYBE = 'maybe',
  DUPLICATE = 'duplicate',
}

export type ReviewDetails = {
  review_decision?: ReviewDecision;
  review_note?: string;
};
